module.exports = __webpack_public_path__ + "img/emoji-mashup-bot.cce8d606.png";